import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

const steps = [
  "1. Entenda como funciona o transporte de veículos",
  "2. O que preciso saber antes de contratar o transporte?",
  "3. Pagamento, cancelamento e reembolso",
  "4. Durante o transporte: rastreamento, prazo e coleta",
  "5. Seguro e sinistros",
  "6. Serviços adicionais e diferenciais",
  "7. Após a entrega: dúvidas e suporte",
].map((label, i) => ({ value: `step${i + 1}`, label }));

export default function FaqStepsNav({
  defaultValue = "step1",
  onStepChange,
}: {
  defaultValue?: string;
  onStepChange?: (step: string) => void;
}) {
  return (
    <div className="w-full mb-5">
      <Tabs
        defaultValue={defaultValue}
        className="w-full h-full"
        onValueChange={onStepChange}
      >
        <TabsList className="grid h-full w-full gap-4 auto-rows-[4rem] sm:auto-rows-[8rem] sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 items-start">
          {steps.map(({ value, label }) => (
            <TabsTrigger
              key={value}
              value={value}
              className="flex h-full w-full items-start justify-start rounded-[20px] border border-n-neutral-lighter px-4 py-3 text-left font-semibold leading-snug text-n-text-neutral text-sm md:text-base whitespace-normal break-words transition data-[state=active]:bg-n-green-s-light data-[state=active]:text-n-green data-[state=active]:border-none"
            >
              {label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
}
